<template>

    <div class='vwrap '>

        <link href="//vjs.zencdn.net/7.8.2/video-js.min.css" rel="stylesheet">
        <video playsinline webkit-playsinline ref="videoPlayer" class="video-js" :class="{'vjs-16-9':!b.small}" :style="{ width: '100%', marginTop: '0px'}"
               muted></video>
    </div>
</template>
<script>
    import videojs from 'video.js';

    export default {
        name: "Fullvideo",
        props: {
            options: {
                type: Object,
                default() {
                    return {};
                }
            },
            height: {type: String},
            b: {type: Object}
        },
        data() {
            return {
                player: null
            }
        },
        mounted() {
            this.player = videojs(this.$refs.videoPlayer, this.getOptions(this.b), function onPlayerReady() {
            })
        },
        watch: {
            b() {
                if (this.player) {
                    this.player.src({type: "video/mp4", src: this.b.video.url});
                }
                else {
                    this.player = videojs(this.$refs.videoPlayer, this.getOptions(this.b), function onPlayerReady() {
                    })
                }
            }
        },
        updated() {
            this.player = videojs(this.$refs.videoPlayer, this.getOptions(this.b), function onPlayerReady() {
            })
        },
        beforeDestroy() {
            if (this.player) {
                this.player.dispose()
            }
        },
        methods: {
            getOptions(b) {
                return {
                    autoplay: false,
                    controls: true,
                    loop: false,
                    height: 'auto',
                    poster: require('@/assets/Startbild-02.png'),
                    sources: [
                        {
                            src:
                            b.video.url,
                            type: "video/mp4"
                        }
                    ]
                }
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>

    video {
        /*height: 500px;*/

        @include mobile {
            //height: 320px;
        }
    }

    .vwrap {
        div {
            @include mobile {
                //max-height: 320px;
                //max-width: 320px;
            }
        }

        overflow: hidden;
        max-width: 100%;
        position: relative;
        /*top: 0;*/
        width: 100%;
        /*height: 480px;*/
        @include mobile {
            //width: 320px;
            //height: 320px;
        }
        /*<!--z-index: -10;-->*/
    }

</style>
